import './BuildStamp.css'

/**
 * Which build am I actually running? Without this, a stale service-worker
 * cache is indistinguishable from a bug, and the only way to tell was to
 * guess.
 */
export function BuildStamp() {
  return <div className="build-stamp">v{__BUILD_ID__}</div>
}
